import React from 'react'
import {Route, Switch} from 'react-router-dom'

import ArticleDetails from '@progyny/pages/KnowledgeCenter/Article/Details'
import {RouteEnum, useRoutes} from '@progyny/routes'

const Article = () => {
  const {getPath} = useRoutes()

  return (
    <Switch>
      <Route
        path={`${getPath(RouteEnum.ARTICLES)}/:slug`}
        component={ArticleDetails}
      />
    </Switch>
  )
}

export default Article
